import { TechnicalPlanTable } from '@bulthaup/api/db';
import { Button } from '@mantine/core';
import { modals } from '@mantine/modals';
import { notifications } from '@mantine/notifications';
import { IconTool } from '@tabler/icons-react';
import { TRPCClientError } from '@trpc/client';
import { isEqual } from 'lodash';

import { trpc } from '../../../../../../services/trpc';
import TechnicalPlanTableForm from './technical-plan-table-form';

export function TechnicalPlanTableButton({
  projectId,
  technicalPlanTable,
  onSuccess = () => {},
  label,
}: {
  projectId: string;
  technicalPlanTable: TechnicalPlanTable | null;
  onSuccess?: () => void;
  label: string;
}) {
  const updateTechnicalPlanTable =
    trpc.projects.updateTechnicalPlanTable.useMutation();

  const handleUpdateTechnicalPlanTable = () => {
    modals.open({
      size: 'lg',
      title: 'Modification du tableau technique',
      children: (
        <TechnicalPlanTableForm
          technicalPlanTable={technicalPlanTable}
          onSubmit={async values => {
            try {
              const hasChanges = !isEqual(values, technicalPlanTable);

              if (!hasChanges) {
                modals.closeAll();
                return;
              }
              await updateTechnicalPlanTable.mutateAsync({
                id: projectId,
                technicalPlanTable: values,
              });
              modals.closeAll();
              notifications.show({
                title: 'Tableau du plan technique mis à jour',
                message: 'Le plan technique a été mis à jour avec succès',
                color: 'green',
              });
              onSuccess();
            } catch (e: unknown) {
              console.log('e', e);
              notifications.show({
                title: 'Erreur',
                message:
                  e instanceof TRPCClientError
                    ? e.message
                    : 'Erreur lors de la mise à jour du plan technique',
                color: 'red',
              });
            }
          }}
        />
      ),
    });
  };

  return (
    <Button
      variant="outline"
      leftSection={<IconTool size={16} />}
      loading={updateTechnicalPlanTable.isPending}
      onClick={handleUpdateTechnicalPlanTable}
      disabled={updateTechnicalPlanTable.isPending}
    >
      {label}
    </Button>
  );
}
